import { UserAvatarService } from '@/domains/spaces/services/user-avatar-service.interface';
import { useDisposes } from '@/presentation/composables/use-disposes';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';
export const useUserAvatars = createSharedComposable(() => {
    const userAvatarService = injectService(UserAvatarService);
    const { disposes } = useDisposes();
    const userAvatarSet = ref(userAvatarService.userAvatarSet);
    disposes.push(userAvatarService.subscribe((dataSet) => {
        userAvatarSet.value = dataSet;
    }));
    const fetchUserAvatarById = (userId) => {
        userAvatarService.fetchUserAvatarById(userId);
    };
    const getUserAvatarById = (userId) => {
        return userId ? userAvatarSet.value[userId] : null;
    };
    return {
        fetchUserAvatarById,
        getUserAvatarById,
    };
});
